import { useState } from 'react';
// import { paymentService } from '../services/payment.service';
import { loadRazorpay } from '../utils/loadRazorpay';
import { toast } from 'react-toastify';

const BASE_URL = 'http://localhost:5000/api';
const VITE_RAZORPAY_KEY = 'rzp_test_SVRXa3surS83r6';
export const apiFetch = async (url, options = {}) => {
	const controller = new AbortController();
	const timeout = setTimeout(() => controller.abort(), 15000);
	try {
		const res = await fetch(`${BASE_URL}${url}`, {
			headers: {
				'Content-Type': 'application/json',
				...(options.headers || {}),
			},
			signal: controller.signal,
			...options,
		});

		const data = await res.json();

		if (!res.ok) {
			throw new Error(data?.message || 'API Error');
		}

		return data;
	} catch (err) {
		if (err.name === 'AbortError') {
			throw new Error('Request timeout');
		}
		throw err;
	} finally {
		clearTimeout(timeout);
	}
};

export const paymentService = {
	createOrder: (payload) =>
		apiFetch('/payment/order', {
			method: 'POST',
			body: JSON.stringify(payload),
		}),

	createSubscription: (payload) =>
		apiFetch('/payment/subscription', {
			method: 'POST',
			body: JSON.stringify(payload),
		}),

	verifyPayment: (payload) =>
		apiFetch('/payment/verify', {
			method: 'POST',
			body: JSON.stringify(payload),
		}),
};

export const usePayment = () => {
	const [loading, setLoading] = useState(false);

	const initiatePayment = async ({ paymentType, plan, navigate }) => {
		try {
			setLoading(true);

			const isLoaded = await loadRazorpay();
			if (!isLoaded) {
				toast.error('Razorpay SDK failed');
				return;
			}

			let response;

			if (paymentType === 'recurring') {
				response = await paymentService.createSubscription({
					planId: 'plan_SY9eTHf1ffa3U6',
					planName: plan.title,
					amount: plan.price,
					discount: 0,
				});
			} else {
				response = await paymentService.createOrder({
					amount: plan.price,
					planName: plan.title,
					discount: 0,
				});
			}
			// 🔥 fetch already returns parsed JSON
			const data = response.data;

			const options = {
				key: VITE_RAZORPAY_KEY,
				currency: 'INR',
				name: 'Pharmnex',
				description: plan.title,

				...(paymentType === 'recurring'
					? { subscription_id: data.id }
					: {
							order_id: data.id,
							amount: data.amount,
						}),

				handler: async (res) => {
					console.log('Razorpay Response:', res);

					const verifyResponse = await paymentService.verifyPayment(res);
					console.log('Payment Verification Response:', verifyResponse);

					toast.success('Payment Successful 🎉');
					const id = res.razorpay_order_id || res.razorpay_subscription_id;

					navigate(`/payment-success?orderId=${id}`);
				},

				modal: {
					ondismiss: () => {
						toast.error('Payment cancelled');
					},
				},

				prefill: {
					name: 'Test User',
					email: 'test@example.com',
					contact: '9999999999',
				},

				theme: { color: '#3B58FF' },
			};

			const rzp = new window.Razorpay(options);
			rzp.open();
		} catch (err) {
			console.error(err);
			toast.error(err.message || 'Payment failed');
		} finally {
			setLoading(false);
		}
	};

	return { initiatePayment, loading };
};

// services/payment.service.ts
// import axios from 'axios';

// export const paymentService = {
//   createOrder: (payload) =>
//     axios.post('/api/order/create-order', payload),

//   createSubscription: (payload) =>
//     axios.post('/api/subscription/create', payload),

//   verifyPayment: (payload) =>
//     axios.post('/api/payment/verify', payload),
// };
